import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.29.0_@playwright+test@1.61.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.29.0_@playwright+test@1.61.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["CelebrityExtension"] */ "/app/src/components/celebrity-extension.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedTopics"] */ "/app/src/components/related-topics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScreenshotGallery"] */ "/app/src/components/screenshot-gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopicSummary"] */ "/app/src/components/topic-summary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopicTrendChart"] */ "/app/src/components/topic-trend-chart-lazy.tsx");
